import { initSwiperSlider, destroySwiperSlider } from "@theme/utilities";

if (!customElements.get("best-sellers-slider")) {
  customElements.define(
    "best-sellers-slider",
    class BestSellersSlider extends HTMLElement {
      constructor() {
        super();
        this.isSyncing = false;
        this.handleMainChange = this.handleMainChange.bind(this);
      }

      connectedCallback() {
        this.optionsSwiper = initSwiperSlider(this, {
          containerSelector: ".swiper-options",
          swiperOptions: {
            loop: true,
            slidesPerView: 1,
            allowTouchMove: false,
            direction: "vertical",
            speed: 300,
          },
        });

        this.titleSwiper = initSwiperSlider(this, {
          containerSelector: ".swiper-titles",
          swiperOptions: {
            loop: true,
            slidesPerView: 1,
            allowTouchMove: false,
            direction: "vertical",
            speed: 300,
          },
        });

        this.descSwiper = initSwiperSlider(this, {
          containerSelector: ".swiper-descriptions",
          swiperOptions: {
            loop: true,
            slidesPerView: 1,
            allowTouchMove: false,
            direction: "vertical",
            speed: 300,
          },
        });

        this.swiper = initSwiperSlider(this, {
          containerSelector: '.image-swiper',
          prevSelector: ".prev-btn",
          nextSelector: ".next-btn",
          swiperOptions: {
            speed: 300,
            loop: true,
            slidesPerView: 1.7,
            centeredSlides: true,
            breakpoints: {
              750: {
                slidesPerView: 3
              }
            }
          },
        });

        if (this.swiper) {
          //fires when realIndex actually changes
          this.swiper.on("realIndexChange", () => this.handleMainChange());
          //sync once on init
          this.swiper.on("init", () => this.handleMainChange());
      
          // If initSwiperSlider initializes immediately
          this.handleMainChange();
        }
      }

      handleMainChange() {
        if (!this.swiper) return;
      
        const index = this.swiper.realIndex ?? 0;

        const activeSlide = this.querySelector(`.image-swiper-slide[data-swiper-slide-index="${index}"]`);

        const priceBlock = this.querySelector('[data-price-block]');
        priceBlock.querySelector('[data-price]').innerHTML = activeSlide.dataset.price;
        priceBlock.querySelector('[data-compare-price]').innerHTML = activeSlide.dataset.comparePrice;

        const badge = this.querySelector(".price-badge");
        if (!badge) return;

        // Restart animation
        badge.classList.remove("is-animating");
        // force reflow so animation can restart
        void badge.offsetWidth;
        badge.classList.add("is-animating");
      
        // Prevent duplicate sync calls for same index
        if (index === this.lastIndex) return;
        this.lastIndex = index;
      
        // Avoid reentrance
        if (this.syncing) return;
        this.syncing = true;
      
        // Ensure controlled swipers exist
        const targets = [this.optionsSwiper, this.titleSwiper, this.descSwiper].filter(
          (s) => s && !s.destroyed
        );
      
        // Sync oll swipers
        targets.forEach((s) => s.slideToLoop(index, this.swiper.params.speed));
      
        // Unlock after the main transition finishes, for some reason its needed for loop mode
        this.swiper.once("slideChangeTransitionEnd", () => {
          this.syncing = false;
        });
      
        // Fallback if transitionEnd doesn’t work for some reason
        setTimeout(() => (this.syncing = false), (this.swiper.params.speed ?? 300) + 50);
      }

      disconnectedCallback() {
        this.swiper?.off("init", this.handleMainChange);
        this.swiper?.off("slideChange", this.handleMainChange);

        destroySwiperSlider(this.swiper);
        destroySwiperSlider(this.optionsSwiper);
        destroySwiperSlider(this.titleSwiper);
        destroySwiperSlider(this.descSwiper);

        this.swiper = null;
        this.optionsSwiper = null;
        this.titleSwiper = null;
        this.descSwiper = null;
      }
    }
  );
}
